import { useSiteContact, waHref } from "@/hooks/useSiteContact";

interface WhatsAppButtonProps {
  /** Extra bottom offset in case a sticky bar is present */
  offsetBottom?: string;
  message?: string;
}

const WhatsAppButton = ({
  offsetBottom = "bottom-24 md:bottom-28",
  message = "Hello! I would like to book a private transfer in Punta Cana.",
}: WhatsAppButtonProps) => {
  const { whatsapp } = useSiteContact();
  const href = `${waHref(whatsapp)}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Express Punta Cana on WhatsApp"
      className={`fixed ${offsetBottom} right-4 md:right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-xl shadow-black/25 transition-transform hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#25D366]`}
    >
      {/* Official WhatsApp glyph */}
      <svg
        viewBox="0 0 32 32"
        width="30"
        height="30"
        aria-hidden="true"
        focusable="false"
        fill="#FFFFFF"
      >
        <path d="M16.003 3.2c-7.06 0-12.79 5.73-12.79 12.79 0 2.253.59 4.457 1.712 6.4L3.2 28.8l6.57-1.712a12.74 12.74 0 0 0 6.233 1.588h.005c7.06 0 12.79-5.73 12.79-12.79 0-3.417-1.33-6.63-3.746-9.046A12.71 12.71 0 0 0 16.003 3.2zm0 23.31h-.004a10.6 10.6 0 0 1-5.4-1.48l-.388-.23-4.003 1.043 1.068-3.903-.253-.4a10.57 10.57 0 0 1-1.62-5.65c0-5.867 4.774-10.64 10.646-10.64 2.843 0 5.514 1.108 7.523 3.12a10.57 10.57 0 0 1 3.116 7.526c-.002 5.868-4.776 10.614-10.685 10.614zm5.84-7.96c-.32-.16-1.894-.934-2.188-1.04-.293-.107-.507-.16-.72.16-.214.32-.827 1.04-1.014 1.253-.187.214-.373.24-.693.08-.32-.16-1.352-.498-2.575-1.588-.952-.849-1.594-1.897-1.78-2.217-.187-.32-.02-.493.14-.652.144-.144.32-.373.48-.56.16-.187.213-.32.32-.533.107-.214.053-.4-.027-.56-.08-.16-.72-1.736-.987-2.376-.26-.624-.524-.54-.72-.55l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.094-1.12 2.67s1.147 3.096 1.307 3.31c.16.213 2.257 3.446 5.47 4.833.764.33 1.36.527 1.825.674.767.244 1.464.21 2.016.128.615-.092 1.894-.774 2.16-1.522.267-.747.267-1.387.187-1.52-.08-.134-.293-.214-.613-.374z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
